import React, { Component } from "react";

import PropsType from "prop-types";

import { Accessor, ColorX } from "../STATIC";
import _ from "lodash";

/**
 * Outlined Box
 * @augments {Component<Props, State>}
 */
class XFieldSet extends Component {

  static propTypes = {
    label: PropsType.string,
    style: PropsType.object,
    borderColor: PropsType.string,
    fontColor: PropsType.string,
    legendAlign: PropsType.string,
    legendStyle: PropsType.object,
  }

  static defaultProps = {
    label: "",
    style: {},
    borderColor: ColorX.CSS("greyOut", 0.5),
    fontColor: ColorX.CSS("greyOut"),
    legendAlign: "left",
    legendStyle: {}
  }

  constructor(){
    super();

    this.state = {
      labelWidth: 100,
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(XFieldSet.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
        return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }));
  }

  render(){
    let { style, label, children, borderColor, 
      fontColor, legendAlign, legendStyle} = this.props;

    return (
      <fieldset style={{
        border: borderColor,
        borderWidth: 1,
        borderStyle: "solid",
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
        paddingBottom: 8,
        borderRadius: 4,
        ...style
        }}>
        {!_.isEmpty(label) && 
          <legend style={{
            fontSize: 8, 
            fontFamily: "sans-serif",
            color: fontColor,
            paddingLeft: 5,
            paddingRight: 5,
            width: "fit-content", 
            boxSizing: "border-box",
            textAlign: legendAlign,
            ...legendStyle
            }}>{label}</legend>
          }
        {children}
      </fieldset>
    );
  }

}

export default XFieldSet;

